export default "__VITE_ASSET__Bwp_IG6s__"